window.addEventListener('SITE_START', () => {
  const $section = document.querySelector('.sub-kv');

  if (!$section) return;

  const $inner = $section.querySelector('.__inner');
  const $frame = $section.querySelector('.__frame');
  const $headline = $section.querySelector('.__headline.--static');
  const $cropWrapper = $section.querySelector('.__crop');
  const $cropImage = $cropWrapper.querySelector('.__image img');
  const $cropHeadline = $cropWrapper.querySelector('.__headline.--dynamic');
  let isDesktop = window.innerWidth >= 1024;

  // 계산용 함수
  const getDiffY = () => $inner.clientHeight - $frame.clientHeight;
  const getDiffX = () => ($inner.clientWidth - $frame.clientWidth) / 2;
  const getScale = () => $frame.clientWidth / $inner.clientWidth;

  let cropValues = initCrop();
  createScrollTrigger();

  function createScrollTrigger() {
    const distance = window.innerHeight;
    isDesktop = window.innerWidth >= 1024;

    ScrollTrigger.create({
      trigger: $section,
      start: 'top top',
      end: '+=' + distance + 'px',
      scrub: true,
      pin: $cropHeadline,
      invalidateOnRefresh: true,
      onUpdate: (self) => {
        const limit = 0.3;
        const clampedProgress = Math.min(self.progress, limit);
        const progress = clampedProgress / limit;

        const { DIFF_Y, DIFF_X, ROUND, BOTTOM, SCALE } = cropValues;
        const offsetY = DIFF_Y - getDiffY() * progress;
        const offsetX = DIFF_X - getDiffX() * progress;
        const offsetS = (1 - getScale()) * progress;
        const round = ROUND - progress * ROUND;
        const bottom = BOTTOM - progress * BOTTOM;

        gsap.set($cropImage, { '--scale': SCALE + offsetS });
        gsap.set($cropWrapper, {
          '--clip-y': offsetY + 'px',
          '--clip-x': offsetX + 'px',
          '--clip-bt': bottom + 'px',
          '--clip-r': round + 'px',
        });
        gsap.set($cropHeadline, { width: $headline.clientWidth + 'px' });
      },
    });

    ScrollTrigger.create({
      trigger: $section,
      start: 'top top',
      end: '+=' + distance + 'px',
      scrub: true,
      pin: $headline,
      pinSpacing: false,
      onUpdate: (self) => {
        if (isDesktop) {
          const limit = 0.4;
          const clamped = Math.min(self.progress, limit);
          const p = clamped / limit;
          const dist = window.innerHeight * 0.1;

          // self.progress가 opacityStart 이상일 때부터 점차 0으로 변경
          const opacityStart = 0.2;
          const opacity =
            self.progress < opacityStart
              ? 1
              : Math.max(0, 1 - (self.progress - opacityStart) / (1 - opacityStart));

          gsap.set($headline, { y: p * dist + 'px' });
          gsap.set($cropHeadline, { y: p * dist + 'px', opacity });
        } else {
          const p = self.progress;
          const dist = window.innerHeight * 0.3;

          // self.progress가 opacityStart 이상일 때부터 점차 0으로 변경
          const opacityStart = 0.2;
          const opacity =
            self.progress < opacityStart
              ? 1
              : Math.max(0, 1 - (self.progress - opacityStart) / (1 - opacityStart));

          gsap.set($headline, { y: p * dist + 'px' });
          gsap.set($cropHeadline, { y: p * dist + 'px', opacity });
        }
      },
    });
  }

  /**
   * Crop 초기 상태 세팅
   */
  function initCrop() {
    const DIFF_Y = getDiffY();
    const DIFF_X = getDiffX();
    const SCALE = getScale();
    const ROUND = 12;
    const BOTTOM = isDesktop ? 48 : 29;

    gsap.set($cropImage, { '--scale': SCALE });
    gsap.set($cropWrapper, {
      '--clip-y': DIFF_Y + 'px',
      '--clip-x': DIFF_X + 'px',
      '--clip-bt': BOTTOM + 'px',
      '--clip-r': ROUND + 'px',
    });

    return { DIFF_Y, DIFF_X, ROUND, BOTTOM, SCALE };
  }

  /**
   * Resize 대응
   */
  detectRealResize(() => {
    cropValues = initCrop();
    createScrollTrigger();
  });
});
